// MOSTRAR MÁS de la PLP (guía SS25): trae la siguiente página y agrega las
// tarjetas al grid sin recargar. Delegado en document porque facets.js
// reemplaza el contenido de #ProductGridContainer al filtrar/ordenar.
document.addEventListener('click', (event) => {
  const button = event.target.closest('.tbl-load-more');
  if (!button) return;
  event.preventDefault();
  if (button.classList.contains('is-loading')) return;

  button.classList.add('is-loading');
  fetch(button.href)
    .then((response) => response.text())
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grid = document.getElementById('product-grid');
      const newItems = doc.querySelectorAll('#product-grid .grid__item');
      newItems.forEach((item) => grid.appendChild(item));

      const nextButton = doc.querySelector('.tbl-load-more');
      if (nextButton) {
        button.href = nextButton.href;
        button.classList.remove('is-loading');
      } else {
        button.closest('.tbl-load-more-wrapper').remove();
      }
    })
    .catch(() => {
      // Si el fetch falla, navega de forma normal como fallback.
      window.location.href = button.href;
    });
});
